import Upload from "../../components/upload";


const SupportAttachmentsPage = ({ id, isControlTower }: { id: string, isControlTower: boolean }) => {
    return (
        <Upload id="attachmentsSupport" path={id} disabled={false} showList isControlTower={isControlTower} />
    )
}

export default SupportAttachmentsPage;